import { CustomerStatus } from '../../models';
export const isCustomerPendingActivation = ({ status }) => [CustomerStatus.Registered, CustomerStatus.Identified, CustomerStatus.PendingAcceptance].includes(status);
export const isCustomerOffBoarding = ({ status }) => status &&
    [CustomerStatus.TerminationRequested, CustomerStatus.TerminationInitiated].includes(status);
//# sourceMappingURL=customerStatus.js.map